import { render } from "./BodyView.vue?vue&type=template&id=f821fe3c"
import script from "./BodyView.vue?vue&type=script&lang=js"
export * from "./BodyView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__